import React from 'react';
import { Link } from 'react-router-dom';
import OptionsByCard from '../optionSummary/OptionsByCard';
import OptionsPage from '../../../common/OptionsPage';
import { withNotifications } from '../../../common/notifications/NotificationsContext';
import Translate from '../../../../core/translate/Translate';
import { translate } from '../../../utils/translate/translations';
import { get } from 'lodash';

const DealerInstalledAccessories = ({ config, pricing, notifications }) => {
  const selectedDealerInstalledOptions = get(
    config.summary,
    'accessories.options'
  );
  return (
    <>
      {selectedDealerInstalledOptions ? (
        <div className="dealer-installed-accessories">
          <div className="dealer-installed-accessories__summary">
            <div className="dealer-installed-accessories__label-container">
              <div className="dealer-installed-accessories__label">
                <Translate value="accessories.price.label" />
              </div>
              <div className="dealer-installed-accessories__change-link">
                <Link to={`../options`}>change</Link>
              </div>
            </div>
            <div className="dealer-installed-accessories__total">
              <a
                className="test"
                onClick={(event) => {
                  event.preventDefault();
                  notifications.show(
                    translate('accessories.price.disclaimer'),
                    event
                  );
                }}>
                &#43;&nbsp;
                {pricing.accessoriesTotal.text}
                <sup className="dealer-installed-accessories__total-dagger">&#8225;</sup>
                <sup className="dealer-installed-accessories__total-asterisk">**</sup>
              </a>
            </div>
          </div>
          <div>
            {' '}
            <OptionsPage>
              {({ onChange, onDetails }) => (
                <OptionsByCard
                  selectedOptions={selectedDealerInstalledOptions}
                  onChange={onChange}
                  onDetails={onDetails}
                />
              )}
            </OptionsPage>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default withNotifications(DealerInstalledAccessories);
